// extracted by mini-css-extract-plugin
export default {"root":"RestrictionPopOver-root_XRVnD","active":"RestrictionPopOver-active_u1u5E"};